module.exports = __webpack_public_path__ + "img/error-2.e9fd7027.svg";